import { defineStore } from "pinia";
import http from "@/http";
import { LIST_CONSUMIVEL, ADD_CONSUMIVEL, UPDATE_CONSUMIVEL, DEL_CONSUMIVEL } from "@/http/url";

export const useConsumivelStore = defineStore("ConsumivelStore", {
  state: () => {
    return {
      consumiveis: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_CONSUMIVEIS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_CONSUMIVEL)
          .then((response) => {
            this.consumiveis = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_CONSUMIVEL(consumivel) {
      return http
        .post(ADD_CONSUMIVEL, consumivel)
        .then((response) => this.consumiveis.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_CONSUMIVEL(consumivel) {
      return http.put(`${UPDATE_CONSUMIVEL + consumivel.id}`, consumivel);
    },

    REMOVER_CONSUMIVEL(id) {
      return http
        .delete(`${DEL_CONSUMIVEL + id}`)
        .then(() => (this.consumiveis = this.consumiveis.filter((c) => c.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getConsumiveis() {      
      return this.consumiveis;
    },

    getConsumivelLoad(state) {
      return state.loaded;
    },

    getFilterConsumiveis: (state) => {
      return (filtro) => state.consumiveis.filter((c) => !filtro || c.descricao.includes(filtro));
    },
  },
});